export default __webpack_public_path__ + "static/food-waste-68a813faa487885d706cab18053c9cf5.jpg";